// extracted by mini-css-extract-plugin
module.exports = {"root":"Notifications_root__BZGrk","main":"Notifications_main__2aOpH","description":"Notifications_description__2Ysr-"};